/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetMostRecentlyViewedStatus200 } from '../models/GetMostRecentlyViewed'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getMostRecentlyViewed } from '../clients/axios/getMostRecentlyViewed'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getMostRecentlyViewedQueryKey = () => [{ url: '/courses/most-recently-viewed' }] as const

type GetMostRecentlyViewedQueryKey = ReturnType<typeof getMostRecentlyViewedQueryKey>

export function getMostRecentlyViewedQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getMostRecentlyViewedQueryKey()
  return queryOptions<GetMostRecentlyViewedStatus200, ResponseErrorConfig<Error>, GetMostRecentlyViewedStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getMostRecentlyViewed({ ...config, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Most Recently Viewed
 * {@link /courses/most-recently-viewed}
 */
export function useGetMostRecentlyViewed<TData = GetMostRecentlyViewedStatus200, TQueryData = GetMostRecentlyViewedStatus200, TQueryKey extends QueryKey = GetMostRecentlyViewedQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetMostRecentlyViewedStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getMostRecentlyViewedQueryKey()

  const queryResult = useQuery({
   ...getMostRecentlyViewedQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
